import React from 'react';
import { StoryCard } from '../StoryCard';

class TrueOrFalseCard extends StoryCard<any> {
	render() {
		return <div className="true-or-false-card">{super.renderCard()}</div>;
	}
}

export default TrueOrFalseCard;
